
export abstract class UICommandContext
{
  abstract is( variable:string ):boolean;

  evaluateCondition( condition:string )
  {
    if ( ! condition || condition.length === 0 )
    {
      return true;
    }

    let conditions = condition.split( /\&\&/ );

    for ( let c of conditions )
    {
      if ( ! this.is( c.trim() ) )
      {
        return false;
      }
    }

    return true;
  } 
}